<template>
  <section id="LoginService">
    <div
      v-if="!onload"
      class="list-invite"
    >
      <div class="align-items-center align-items-md-start border-bottom flex-column flex-md-row media pb-3 px-4">
        <div class="text-teal mr-md-3 align-self-md-center mb-3 mb-md-0">
          <img
            :src="$storeIndex.getImageGobalAssets('logo_google')"
            class="mr-1"
            alt=""
          >
        </div>
        <div class="media-body text-center text-md-left my-auto">
          <h6 class="media-title font-weight-semibold">
            {{ $t('Google Account') }}
          </h6>
          <!-- <div><a href="#"><u>{{$t('patrick_pppat@info.com')}}</u></a></div> -->
        </div>
        <ladda
          slot="finish" 
          text="Disconnect"   
          :btn-class="'btn btn-outline-danger align-self-md-center ml-md-3 mt-3 mt-md-0'" 
          @click="showAlert(getId('google'))"
          v-if="filter('google')" 
          icon="<i class='far fa-unlink'></i>"
        />
        <ladda
          slot="finish" 
          text="Connect"   
          :btn-class="'btn btn-outline-primary align-self-md-center ml-md-3 mt-3 mt-md-0'" 
          @click="handleBtnLinkSocial('google')"
          v-else 
          icon="<i class='far fa-link'></i>"
        />
      </div>
      <div class="align-items-center align-items-md-start border-bottom flex-column flex-md-row media pb-3 px-4">
        <div class="text-teal mr-md-3 align-self-md-center mb-3 mb-md-0">
          <img
            :src="$storeIndex.getImageGobalAssets('logo_facebook')"
            class="mr-1"
            alt=""
          >
        </div>
        <div class="media-body text-center text-md-left my-auto">
          <h6 class="media-title font-weight-semibold">
            {{ $t('Facbook Account') }}
          </h6>
          <!-- <div><a href="#"><u>{{$t('Connect to Facebook')}}</u></a></div> -->
        </div>
        <ladda
          slot="finish" 
          text="Disconnect"   
          :btn-class="'btn btn-outline-danger align-self-md-center ml-md-3 mt-3 mt-md-0'" 
          @click="showAlert(getId('facebook'))"
          v-if="filter('facebook')" 
          icon="<i class='far fa-unlink'></i>"
        />
        <ladda
          slot="finish" 
          text="Connect"   
          :btn-class="'btn btn-outline-primary align-self-md-center ml-md-3 mt-3 mt-md-0'" 
          @click="handleBtnLinkSocial('facebook')"
          v-else 
          icon="<i class='far fa-link'></i>"
        />
      </div>
      <div class="align-items-center align-items-md-start border-bottom flex-column flex-md-row media pb-3 px-4">
        <div class="text-teal mr-md-3 align-self-md-center mb-3 mb-md-0">
          <img
            :src="$storeIndex.getImageGobalAssets(`logo_line`)"
            class="mr-1"
            alt=""
          >
        </div>
        <div class="media-body text-center text-md-left my-auto">
          <h6 class="media-title font-weight-semibold">
            {{ $t(`Line Account`) }}
          </h6>
          <!-- <div><a href="#"><u>{{$t('Connect to Line')}}</u></a></div> -->
        </div>
        <ladda
          slot="finish" 
          text="Disconnect"   
          :btn-class="'btn btn-outline-danger align-self-md-center ml-md-3 mt-3 mt-md-0'" 
          @click="showAlert(getId('line'))"
          v-if="filter('line')" 
          icon="<i class='far fa-unlink'></i>"
        />
        <ladda
          slot="finish" 
          text="Connect"   
          :btn-class="'btn btn-outline-primary align-self-md-center ml-md-3 mt-3 mt-md-0'" 
          @click="handleBtnLinkSocial('line')"
          v-else 
          icon="<i class='far fa-link'></i>"
        />
      </div>
      <div class="align-items-center align-items-md-start flex-column flex-md-row media pb-3 px-4">
        <div class="text-teal mr-md-3 align-self-md-center mb-3 mb-md-0">
          <img
            :src="$storeIndex.getImageGobalAssets(`logo_apple`)"
            class="mr-1"
            alt=""
          >
        </div>
        <div class="media-body text-center text-md-left my-auto">
          <h6 class="media-title font-weight-semibold">
            {{ $t(`Apple ID Account`) }}
          </h6>
          <!-- <div><a href="#"><u>{{$t('Connect to Line')}}</u></a></div> -->
        </div>
        <ladda
          slot="finish" 
          text="Disconnect"   
          :btn-class="'btn btn-outline-danger align-self-md-center ml-md-3 mt-3 mt-md-0'" 
          @click="showAlert(getId('apple'))"
          v-if="filter('apple')" 
          icon="<i class='far fa-unlink'></i>"
        />
        <ladda
          slot="finish" 
          text="Connect"   
          :btn-class="'btn btn-outline-primary align-self-md-center ml-md-3 mt-3 mt-md-0'" 
          @click="handleBtnLinkSocial('apple')"
          v-else 
          icon="<i class='far fa-link'></i>"
        />
      </div>
    </div>
    <div v-else>
      <div>
        <placeholder-content is-load="true" />
      </div>
    </div>
  </section>
</template>


<script>
window.Pusher = require('pusher-js');
import CentralApi from '@/services/endpoint/central.service'
import PlaceholderContent from '@/plugins/PlaceholderContent.vue'
import Ladda from '@/plugins/Ladda.vue'
import { v4 as uuid } from 'uuid';
import WebSocket from "isomorphic-ws";

export default {
    components: {
      PlaceholderContent,
      Ladda
    },
    data() {
        return {
            social:[],
            onload: true,
        }
    },
    methods:{
        handleBtnLinkSocial(provider){
            if((provider === 'facebook' || provider === 'apple') && process.env.NODE_ENV === 'local') return ;

            const uuidV4 = uuid.v4()
            const ws = new WebSocket(process.env.WEBSOCKETS_GOQUEUE_URL)
            
            window.open(process.env.API_BASE_URL + `/v1/auth/${provider}/login?code=${uuidV4}`);
            //start websockets
            if(provider == 'apple') {
                //web sockets listen
                const self = this

                ws.onopen = function open() {
                  ws.send(JSON.stringify({
                    data: {
                        clientUid: "socialAppleLoginChannel" + uuidV4
                    },
                    event : "subscribe"
                  }));
                };

                ws.onmessage = async (e) => {
                  const {data} = JSON.parse(e.data)

                  if(data.message === 'done') {
                    const queryString = `id=${window.btoa(data.data)}&action_type=login`
                    const response = await CentralApi.Auth.socialAppleActions(queryString)
                    const reponseMessage = response.data.message 
                    
                    if(reponseMessage === 'linkSuccess') {
                        await this.fetchUserSocial()
                    }

                    if(reponseMessage === 'alreadyAccount') {
                        self.$toastr.e(self.$t('Account already in use. Please try another account.'), self.$t('Connection Failed')+"..." )
                    }
                  }
                }
                
            } else {
                ws.onopen = function open() {
                  ws.send(JSON.stringify({
                    data: {
                        clientUid: "socialLinkAccountChannel" + uuidV4
                    },
                    event : "subscribe"
                  }));
                };

                ws.onmessage = async (e) => {
                  const {data} = JSON.parse(e.data)
                  if(data.message === 'linkSuccess' ) {
                      await this.fetchUserSocial()
                  };
                }
                  
            }
        },
        filter(provider){
            return this.social.filter(n=> n.provider_name == provider).length == 1;
        },
        getId(provider){
            return this.social.filter(n => n.provider_name == provider)[0].id
        },
        async fetchUserSocial(){
            this.onload = true;
            const response = await CentralApi.SocialAccount.getSocialAccount()
            
            if(response.status == 200) {
                this.onload = false;
                const data = response.data.data;
               
                this.social = data
            }
            
        },
        showAlert(id) {
            var self = this;
            this.$swal.fire({
                icon: 'question',
                title: this.$t('Are you sure you want to disconnect')+" ?",
                html: this.$t('You will not be able to undo this action.'),
                focusConfirm: true,
                showCancelButton: true,
                confirmButtonText: '<i class="fas fa-check-circle mr-2"></i>'+this.$t('Confirm'),
                cancelButtonText: this.$t('Cancel'),
                iconColor: '#455d68',
                // iconColor: '#FF7043',
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-primary mr-2',
                    cancelButton: 'btn btn-outline-normal'
                },
                showLoaderOnConfirm: true,
                preConfirm: async function() {
                   return new Promise((resolve, reject) => {
                            CentralApi.SocialAccount.deleteSocialAccount(id).then((rs) => {
                                
                                if(rs.status == 200) {
                                    self.onload = true;
                                    setTimeout(()=>{
                                        self.social = self.social.filter(item=> item.id !=id);
                                        self.onload = false;
                                    },800)
                                    resolve();
                                }
                                
                                if(rs.status == 500) throw(rs.data.message); return;

                            }).catch((error) => {
                                console.log(error);
                                self.$swal.showValidationMessage(error);
                                reject(error)
                            })
                        });
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    console.log("confirm")
                }else{
                    console.log("cancel");
                }
            })
        },
    },
    mounted(){
        this.fetchUserSocial()
    }
}
</script>

<style scoped>
    img{
        height: 35px;
        width: 35px;
    }
</style>




// WEBPACK FOOTER //
// src/components/central/account/profile/LoginService.vue